<template>
  <div class="ls-support-header">
    <div class="ls-support-header--back" test-id="back_link" @click="onClick">
      <span class="ls-support-header--back-link" test-id="back">
        <LsIcon class="ls-support-header--chevron" type="chevron" size="md" />
        BACK
      </span>
    </div>
    <h1>{{ label }}</h1>
  </div>
</template>

<script>
import { LsIcon } from '@/components/common';
import VueTypes from 'vue-types';

export default {
  name: 'LsSupportHeader',
  components: {
    LsIcon,
  },
  props: {
    label: VueTypes.string.isRequired,
    backRoute: VueTypes.string,
  },
  methods: {
    onClick() {
      if (this.backRoute) {
        this.$router.push({
          name: this.backRoute,
        });
        return;
      }

      const { prevRouteName } = this.$route.meta;

      if (prevRouteName) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          name: 'support',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-support-header {
  h1 {
    font-weight: 700;
  }
}
.ls-support-header--back {
  margin-bottom: 15px;
  @media (max-width: $mobile-max-width) {
    padding-bottom: 15px;
    border-bottom: 1px solid $primary-light;
  }
}

.ls-support-header--back-link {
  cursor: pointer;
  color: $primary;
  font-weight: bold;
}

.ls-support-header--chevron {
  vertical-align: bottom;
  margin-right: 3px;
  transform: rotate(180deg);
}
.themed-app {
  .ls-support-header--back {
    @media (max-width: $mobile-max-width) {
      border-color: $theme-color-primary-light;
    }
  }

  .ls-support-header--back-link {
    color: $theme-color-primary;
  }
}
</style>
